export default __webpack_public_path__ + "media/images/projekktor-maccaco/maccaco-load-50d24dd95111441e149c07c30b747e3f.gif";